export const GET_DASHBOARD = 'GET_DASHBOARD'
export const GET_DASHBOARD_SUCCESS = 'GET_DASHBOARD_SUCCESS'
export const GET_DASHBOARD_FAIL = 'GET_DASHBOARD_FAIL'
